import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FormControlInput } from "../../../../components/organisms/Form/control";
import { ButtonT1 } from "../../../../components/atoms/Button/Button";
import { ManageGeneralFormProvider } from "../../../../components/organisms/Provider/ManageGeneralFormProvider";
import { FormCard, FormTitle, FormSubtitle, BackLink, ErrorMessage } from "../index.styles";
import { usePortalRequestPasswordResetMutation } from "../../../../store/apiSlice/portalAuthApiSlice";
import { selectPortalId } from "../../../../store/slice/portalContextSlice";

const ForgotPassword = () => {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const { subdomain } = useParams();
  const navigate = useNavigate();

  const portalId = useSelector(state => selectPortalId(state, subdomain));
  const [requestPasswordReset, { isLoading }] = usePortalRequestPasswordResetMutation();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email address").required("Email is required"),
    }),
    onSubmit: async values => {
      setError("");
      try {
        await requestPasswordReset({ email: values.email, portal_id: portalId }).unwrap();
        setSubmitted(true);
      } catch (err) {
        setError("Failed to send reset email. Please try again.");
      }
    },
  });

  if (submitted) {
    return (
      <FormCard>
        <FormTitle>Check your email</FormTitle>
        <FormSubtitle>We sent a password reset link to {formik.values.email}</FormSubtitle>
        <BackLink onClick={() => navigate(`/portal/${subdomain}/auth/login`)}>
          Back to Sign in
        </BackLink>
      </FormCard>
    );
  }

  return (
    <FormCard>
      <FormTitle>Forgot password</FormTitle>
      <FormSubtitle>
        Enter your email address and we'll send you a link to reset your password.
      </FormSubtitle>
      <ManageGeneralFormProvider formik={formik}>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-7">
            <FormControlInput
              name="email"
              type="email"
              label="Email"
              placeholder="Email"
              variant="light"
              context="general"
              required
            />
          </div>

          <div className="mb-4">
            <ButtonT1
              title={isLoading ? "Sending..." : "Send Reset Link"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
              $variant="primary"
              $width="100%"
            />
          </div>
        </form>
      </ManageGeneralFormProvider>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <BackLink onClick={() => navigate(`/portal/${subdomain}/auth/login`)}>
        Back to Sign in
      </BackLink>
    </FormCard>
  );
};

export default ForgotPassword;
